// import Vue from 'vue';
// import Router from 'vue-router';
import store from "../store";

import Layout from "@/components/Layout/Layout";

// Pages
import Dashboard from "@/pages/Dashboard/Dashboard";
import Typography from "@/pages/Typography/Typography";
import Reward from "@/pages/Reward/Reward";
import Icons from "@/pages/Icons/Icons";
import Charts from "@/pages/Charts/Charts";
import Maps from "@/pages/Maps/Google";
import Error from "@/pages/Error/Error";
import Forbidden from "@/pages/Forbidden/Forbidden";
import Login from "@/pages/Login/Login";
import ChangePass from "@/pages/ChangePass/ChangePass";
import ForgotPassword from "@/pages/ForgotPassword/ForgotPassword";
import Register from "@/pages/Register/Register";
import PrivacyPolicy from "@/pages/ForgotPassword/PrivacyPolicy";
import Profile from "@/pages/Profile/Profile";
import Products from "@/components/Products/Products";
import Cart from "@/pages/Cart/Cart";
import PurchaseDetails from "@/pages/PurchaseDetails/PurchaseDetails";
import PurchaseDetailsReward from "@/pages/PurchaseDetails/PurchaseDetailsReward";
import PurchaseDetailsNew from "@/pages/PurchaseDetails/PurchaseDetailsNew";
import Transactions from "@/pages/Transactions/Transactions";
import TransactionsList from "@/pages/TransactionList/TransactionList";
import ProductDtl from "@/components/ProductDtl/ProductDtl";
import Payment from "@/pages/Payment/Payment";
import Notifications from "@/pages/Notifications/Notifications";
import NewPassword from "@/pages/NewPassword/NewPassword";

import UserActivation from "@/pages/UserActivation/UserActivation";
import Upline from "@/pages/Upline/Upline";
const prefixPath = ``; //process.env.VUE_APP_PREFIX_ROUTE_PATH

// Vue.use(Router);

export default [
  {
    path: `${prefixPath}/`,
    name: "home",
    meta: {
      name: "",
      requiresAuth: false,
    },
    component: Login,
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next(`${prefixPath}/dashboard`);
      } else {
        next();
      }
    },
  },
  {
    path: `${prefixPath}/login`,
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next(`${prefixPath}/dashboard`);
      } else {
        next();
      }
    },
  },
  {
    path: `${prefixPath}/forgot-password`,
    name: "forgotPassword",
    component: ForgotPassword,
  },
  {
    path: `${prefixPath}/register`,
    name: "register",
    component: Register,
  },
  {
    path: `${prefixPath}/newPassword`,
    name: "newPassword",
    component: NewPassword,
    props: true
  },
  {
    path: `${prefixPath}/aktivasi/:code`,
    name: "userActivation",
    component: UserActivation,
  },
  {
    path: `${prefixPath}/privacy-policy`,
    // beforeEnter() {
    //   window.location.href = '/privacy-policy.html';
    // }
    name: "privacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: `${prefixPath}/`,
    meta: {
      name: "baseLayout",
      requiresAuth: true,
    },
    redirect: `${prefixPath}/login`,
    name: "layout",
    component: Layout,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "payment",
        name: "payment",
        component: Payment,
      },
      {
        path: "change-pass",
        name: "changePass",
        component: ChangePass,
      },
      {
        path: "profile",
        name: "profile",
        component: Profile,
      },
      {
        path: "profile/:tab",
        name: "profileByTab",
        component: Profile,
      },
      {
        path: "typography",
        name: "typography",
        component: Typography,
      },
      {
        path: "reward",
        name: "reward",
        component: Reward,
      },
      {
        path: "icons",
        name: "icons",
        component: Icons,
      },
      {
        path: "charts",
        name: "charts",
        component: Charts,
      },
      {
        path: "maps",
        name: "maps",
        component: Maps,
      },
      {
        path: "products/:mode",
        name: "products",
        component: Products,
        props: true
      },
      {
        path: "cart",
        name: "cart",
        component: Cart,
      },
      {
        path: "cart/:cartStatus",
        name: "cartByStatus",
        component: Cart,
        props: true,
      },
      {
        path: `forbidden`,
        name: "forbidden",
        component: Forbidden,
      },
      {
        path: "purchase-details",
        name: "purchaseDetails",
        component: PurchaseDetails,
      },
      {
        path: "purchase-detailsNew/:mode",
        name: "purchaseDetailsNew",
        component: PurchaseDetailsNew,
        props: true
      },
      {
        path: "purchase-details/:orderId/:mode",
        name: "purchaseDetailsByOrderId",
        component: PurchaseDetails,
        props:true
      },
      {
        path: "purchase-details-reward/:orderId",
        name: "purchaseDetailsByOrderId",
        component: PurchaseDetailsReward,
        props:true
      },
      {
        path: "transactions/:tab",
        name: "transactions",
        component: Transactions,
        props: true,
      },
      {
        path: "transactions/:transStatus",
        name: "transactionsByStatus",
        component: Transactions,
      },
      {
        path: "product/:productCode/:mode/detail",
        name: "productDtl",
        component: ProductDtl,
        props: true
      },
      {
        path: "lihat-transaksi",
        name: "lihatTransaksi",
        component: TransactionsList,
      },
      {
        path: "upline",
        name: "upline",
        component: Upline,
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications,
      },
      // {
      //   path: "newPassword/:email/:token",
      //   name: "newPassword",
      //   component: NewPassword,
      //   props: true
      // },
    ],
  },
  // {
  //   path: `${prefixPath}/forbidden`,
  //   name: 'forbidden',
  //   component: Forbidden,
  // },
  {
    path: "*",
    name: "error",
    component: Error,
  },
];
